export default __webpack_public_path__ + "static/media/PenEdit.5213b6ed.svg";